<template>
    <div class="news_item">
        <component
            :is="isExternalLink ? 'a' : 'nuxt-link'"
            v-bind="linkAttributes"
            class="news_inner block"
        >
            <div class="news_head flex flex_center">
                <div class="date">
                    {{ $dayjs(event.date).format('DD-MM-YYYY') }}
                </div>
            </div>
            <div class="news_body">
                <h3>{{ event.name }}</h3>
                <p>
                    {{ event.description }}
                </p>
            </div>
        </component>
    </div>
</template>

<script>
export default {
    props: {
        event: {
            type: Object,
            required: true
        }
    },

    computed: {
        isExternalLink() {
            return this.event.externalLink;
        },

        linkAttributes() {
            const { article, externalLink } = this.event;

            if (this.isExternalLink) {
                return {
                    href: externalLink,
                    target: '_blank',
                    rel: 'noopener noreferrer'
                };
            }

            if (article) {
                return {
                    to: this.$getArticleLink(article)
                };
            }

            return { to: this.localePath('/') };
        }
    }
};
</script>
